import launchSatellite from '../../assets/images/news/launch_satellite.png';
import developAi from '../../assets/images/news/develop_ai.png';
import inspirationalMurals from '../../assets/images/news/inspirational_murals.png';
import communicationTools from '../../assets/images/news/communication_tools.png';
import mentalHealthSupport from '../../assets/images/news/mental_health_support.png';
import resourceDistribution from '../../assets/images/news/resource_distribution.png';
import setupSafeZones from '../../assets/images/news/setup_safe_zones.png';
import trainingProgram from '../../assets/images/news/training_program.png';

export const hotNewsCards = [
    {
        title: 'BREAKING NEWS',
        content: 'SpaceTec Launches New Satellite for Improved Crisis Management.',
        buttonText: 'Read more',
        imageUrl: launchSatellite,
    },
    {
        title: 'BREAKING NEWS',
        content: 'Community Volunteers Set Up New Safe Zones Across Hackunia.',
        buttonText: 'Read more',
        imageUrl: setupSafeZones,
    },
    {
        title: 'BREAKING NEWS',
        content: 'Hackunia University Develops AI to Predict Alien Movements.',
        buttonText: 'Read more',
        imageUrl: developAi,
    },
    {
        title: 'BREAKING NEWS',
        content: 'Mental Health Support Initiatives Launched by SpaceTec.',
        buttonText: 'Read more',
        imageUrl: mentalHealthSupport,
    },
    {
        title: 'BREAKING NEWS',
        content: 'New Resource Distribution Center Opens in North Hackunia.',
        buttonText: 'Read more',
        imageUrl: resourceDistribution,
    },
    {
        title: 'BREAKING NEWS',
        content: 'Innovative Training Program for Crisis Management Launched.',
        buttonText: 'Read more',
        imageUrl: trainingProgram,
    },
    {
        title: 'BREAKING NEWS',
        content: 'Hackunia Artists Create Inspirational Murals to Boost Morale.',
        buttonText: 'Read more',
        imageUrl: inspirationalMurals,
    },
    {
        title: 'BREAKING NEWS',
        content: 'Tech Companies Collaborate to Develop New Communication Tools.',
        buttonText: 'Read more',
        imageUrl: communicationTools,
    },
];


export const warningCards = [
    'Increased Alien Activity Detected in Southern Regions!',
    'Alien Sightings Near Major Water Sources!',
    'New Type of Alien Detected with Enhanced Abilities!',
    'Report any suspicious activity immediately!',
    'Alien Breach in Northern Safe Zone!',
    'Alien Forces Moving Toward Central Hackunia!',
    'Increased Alien Activity Detected in Southern Regions!',
    'Alien Sightings Near Major Water Sources!',
    'New Type of Alien Detected with Enhanced Abilities!',
    'Report any suspicious activity immediately!',
    'Alien Breach in Northern Safe Zone!',
    'Alien Forces Moving Toward Central Hackunia!',
    'Increased Alien Activity Detected in Southern Regions!',
    'Alien Sightings Near Major Water Sources!',
    'New Type of Alien Detected with Enhanced Abilities!',
    'Report any suspicious activity immediately!',
    'Alien Breach in Northern Safe Zone!',
    'Alien Forces Moving Toward Central Hackunia!',
    'Increased Alien Activity Detected in Southern Regions!',
    'Alien Sightings Near Major Water Sources!',
    'New Type of Alien Detected with Enhanced Abilities!',
    'Report any suspicious activity immediately!',
    'Alien Breach in Northern Safe Zone!',
    'Alien Forces Moving Toward Central Hackunia!',
];

export const contactCardContent = "For any emergency, please contact us at contact@orbitguardians.com.";
